module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-landing-page-layout', [_c('div', {
    staticClass: "flex h-screen overflow-y-auto"
  }, [_c('div', {
    staticClass: "mx-auto mt-12"
  }, [_c('div', {
    staticClass: "flex justify-center"
  }, [_c('img', {
    staticClass: "w-24",
    attrs: {
      "src": "/static/logos/parlay_logo.svg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sign-in-box my-5 box-border shadow-sm p-9 border-1 rounded bg-white"
  }, [_c('p', {
    staticClass: "mb-4 flex justify-center font-bold text-lg"
  }, [_vm._v("New Password")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "font-semibold"
  }, [_vm._v("Enter a new password")]), _vm._v(" "), _c('password', {
    attrs: {
      "badge": false,
      "toggle": true
    },
    nativeOn: {
      "keyup": function($event) {
        _vm.error_msg = null
      }
    },
    model: {
      value: (_vm.new_pwd),
      callback: function($$v) {
        _vm.new_pwd = $$v
      },
      expression: "new_pwd"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "password-text text-gray-400 leading-3"
  }, [_vm._v("\n            Use 8 ore more characters with a mix of letters, numbers &\n            symbols.\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('label', {
    staticClass: "font-semibold"
  }, [_vm._v("Re-enter your password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeat_pwd),
      expression: "repeat_pwd"
    }],
    staticClass: "bg-input text-sm text-gray-500 flex-grow outline-none px-4 py-2 w-full rounded",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.repeat_pwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repeat_pwd = $event.target.value
      }
    },
    nativeOn: {
      "keyup": function($event) {
        _vm.error_msg = null
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "h-5 text-xs text-red-500 italic"
  }, [_vm._v("\n          " + _vm._s(_vm.error_msg) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "px-4 py-2 w-full bg-pinky hover:bg-pinky-dark rounded cursor-pointer text-white font-semibold",
    on: {
      "click": _vm.submitPassword
    }
  }, [_vm._v("\n          Submit\n        ")])])])]), _vm._v(" "), (_vm.show_modal) ? _c('pl-dialog', {
    attrs: {
      "header": "Password has been reset"
    },
    on: {
      "close": _vm.closeDialog
    }
  }, [_c('p', {
    staticStyle: {
      "padding-left": "18px"
    }
  }, [_vm._v("\n      You are now able to login with your new credentials.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "end-xs",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog.apply(null, arguments)
      }
    }
  }, [_vm._v("Back to login")])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-2b4358be!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/authentication/newPwd/newPwd.vue
// module id = 2312
// module chunks = 61